import { render, staticRenderFns } from "./ANewMaxWeb.vue?vue&type=template&id=0c202354&scoped=true"
import script from "./ANewMaxWeb.vue?vue&type=script&lang=js"
export * from "./ANewMaxWeb.vue?vue&type=script&lang=js"
import style0 from "./ANewMaxWeb.vue?vue&type=style&index=0&id=0c202354&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c202354",
  null
  
)

export default component.exports